import { HeaderGroup as HeaderGroupType } from "react-table";
import { genericMemo } from "../../../../../../utils";
import HeaderCell from "./HeaderCell";

type HeaderGroupProps<T extends object> = {
  headers: HeaderGroupType<T>[],
};

const HeaderGroup = genericMemo(
  <T extends object>({ headers, ...restProps }: HeaderGroupProps<T>) => {
    return (
      <div {...restProps}>
        {headers.map(column => {
          const { key } = column.getHeaderProps();
          const span = column.columns?.filter(x => x.isVisible)?.length || 1;
          return <HeaderCell
            style={{ gridColumnEnd: `span ${span}` }}
            key={key}
            column={column}
          />;
        })}
      </div>
    );
  },
);

export default HeaderGroup;
